module.exports = "/next-static/_next/static/images/block_image_stream_anywhere-cbd0c10280fdd3387e7544e29a6d6ed9.webp";